import { IState } from '../../../store';
import { selectAgentLists } from '../selectAgentLists';

export const isShowBankDisclaimer = (state: IState) => {
  const agentLists = selectAgentLists(state);
  const bank = state.offerData.agent?.bank;

  return Boolean(bank || agentLists.includes('pledgeRealty'));
};
